<template>
  <img
    class="social-marketing-studio-image"
    v-if="profilePhoto"
    :src="profilePhoto"
  />
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'SocialMarketingStudioImage',
  props: {
    profilePhoto: {
      type: String,
      required: false,
    },
  },
});
</script>

<style lang="scss" scoped>
@import '@/web/styles/components-variables.scss';

.social-marketing-studio-image {
  position: absolute;
  width: 45px * $social-marketing-card-factor;
  height: 45px * $social-marketing-card-factor;
  object-fit: cover;
  border-radius: 50%;
  border: 3px * $social-marketing-card-factor solid white;
  top: -22px * $social-marketing-card-factor;
  background: white;
}
</style>
